import "./gallery-photo.scss"
import "./comments/_comments.scss"
import "./description/_description.scss"

import GalleryPhotoComponent from "./js/gallery-photo"
import { PHOTO } from "./js/constants"

/**
 * @export
 * @param {Object} settings
 * @param {string} settings.token
 * @param {string} settings.location
 * @param {boolean} settings.loggedIn
 * @param {boolean} settings.memberMode
 * @returns
 */
export default async function run(settings) {
  if (!document.querySelector(PHOTO)) return null

  const galleryPhoto = new GalleryPhotoComponent({
    htmlElement: document,
    ...settings,
  })
  await galleryPhoto.preload(galleryPhoto.state.currentPhoto.id)

  return galleryPhoto
}
